import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { LoaderCircle } from "lucide-react";

const UpdateHome = () => {
  const [email, setEmail] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    if (!email || !isChecked) {
      toast.error("Please enter a valid email and accept the Privacy Policy.");
      return;
    }

    setLoading(true);
    try {
      await axios.post("https://derbyb.ritaz.in/api/subscribe", { email });
      toast.success("Subscribed successfully!");
      setEmail("");
      setIsChecked(false);
    } catch (error) {
      toast.error("This email is already subscribed");
      console.error("Error subscribing:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="update-section-container position-relative">
      <div className="container position-relative">
        <figure className="update-section-circle mb-0">
          <img src="./assets/images/relive-circle.png" alt="image-0" className="img-fluid" />
        </figure>
        <figure className="update-section-triangle mb-0">
          <img src="./assets/images/relive-triangle.png" alt="image-1" className="img-fluid" />
        </figure>
        <div className="row">
          <div className="col-lg-8 col-12 mx-auto">
            <div className="update-section-content text-center" data-aos="fade-up">
              <h2>
                Subscribe For <span>Exclusive Deals</span> and Updates
              </h2>
              <p>Get 10% off your next order and stay updated with our latest offers.</p>
              <form onSubmit={handleFormSubmit}>
                <div className="update-section-form-group float-left position-relative" style={{ width: '100%', clear: 'both' }}>
                  <input
                    type="text"
                    className="update-section-form-style"
                    placeholder="Enter Your Email Address"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button type="submit" disabled={loading}>
                    {loading ? (
                      <LoaderCircle className="animate-spin" size={18} />
                    ) : (
                      <>
                        Subscribe<i className="fa-solid fa-arrow-right ml-1"></i>
                      </>
                    )}
                  </button>
                </div>
                <div className="update-section-checkbox m-0" style={{ clear: 'both' }}>
                  <input
                    type="checkbox"
                    id="privacy"
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                  />
                  <label htmlFor="privacy">
                    I agree to the{" "}
                    <a className="text-decoration-none" href="/privacy">
                      Privacy Policy
                    </a>
                    .
                  </label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpdateHome;
